import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-commit-exchange-table',
  templateUrl: './commit-exchange-table.html',
  styleUrls: ['./commit-exchange-table.scss'],
})
export class CommitExchangeTableComponent {
  @Input() title: string;
  @Input() dataProvider: Array<any>;
  @Input() isDisplayRecom: boolean;

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
